//LIBRARIES
import React, { Component, Fragment } from 'react';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

//COMPONENTS
import WizardWelcomePage from './0_welcome';
import WizardConsentPage from './1_consent';
import WizardAdditionalInformationPage from './1.1_pre_application_instructions';
import TenantPaymentOptions from 'components/tenant_app/components/payments/TenantPaymentOptions';
import { toggleApplicationFeePaymentModal } from 'actions/tenantApplicationActions';
import WizardLeaseDetailsPage from './1.1_leaseDetails';
import WizardLeasePaymentsPage from './1.2_paymentDetails';
import WizardFormSecondPage from './2_cotenants';
import WizardDetailPage from './4_personalDetails';
import WizardBioPage from './5_personalBio';
import WizardQuestionsPage from './6_applicationQuestions';
import WizardCurrentAddressPage from './7_currentAddress';
import WizardOccupationPage from './8_currentOccupation';
import WizardPreviousOccupationPage from './9_previousOccupation';
import EmergencyContactsPage from '../EmergencyContacts';
import WizardIdUploadPage from './12_idUpload';
import PaymentDetails from './13_paymentDetails';
import PADAgreementDialog from 'navigation/PADAgreementDialog';
import StripePayment from 'components/shared/StripePayment';
import PaysafeTenantPayment from 'components/tenant_app/components/payments/paymentDialog/paysafe/PaysafeTenantPayment';

//ACTIONS
import * as tenantApplicationActions from 'actions/tenantApplicationActions';
import { explosionCelebration } from 'actions/notificationActions';
import { getUserPreferences } from 'actions/userTypesActions';

//HELPERS
import { deepDiver } from 'helpers/utilities';

//STYLING
import '../tenant_application.css';

let TenantApplication = connect(
  store => {
    return {
      showLoginForm: store.authentication.showLoginForm,
      showPage: store.authentication.showPage,
      updateSuccessNotice: store.notifications.updateSuccessNotice,
      failureNotice: store.notifications.updateFailureNotice,
      message: store.notifications.message,
      showApplicationForm: store.authentication.showApplicationPage,
      isSending: store.tenantApplication.isSending,
      tenantApplication: store.tenantApplication.tenantApplication,
      applicationAvailable: store.tenantApplication.applicationAvailable,
      privacyStatementLink: store.userTypes.privacyStatementLink,
      uploadedFileErrorsArray: store.tenantApplication.uploadedFileErrorsArray,
      uploadError: store.tenantApplication.uploadError,
      showApplicationFeePayment: store.tenantApplication.appFeePaymentOpen,
      createdApplicationID: store.tenantApplication.createdApplicationID,
    };
  },
  {
    ...tenantApplicationActions,
    explosionCelebration,
    getUserPreferences,
    toggleApplicationFeePaymentModal,
  }
)(
  class WizardForm extends Component {
    constructor(props) {
      super(props);
      this.nextPage = this.nextPage.bind(this);
      this.previousPage = this.previousPage.bind(this);
      this.state = {
        page: this.props.uploadError ? 14 : 0,
        padAgreementOpen: false,
        paymentDialogOpen: false,
        hasPaid: false,
        hasAutopayDetails: false,
      };
    }

    processCreditCardPayment = token => {
      return this.props
        .acceptApplicationPayment(token)
        .then(() => {
          this.setState({
            hasPaid: true,
            hasAutopayDetails: false,
            paymentDialogOpen: false,
          });
        })
        .catch(() => {
          this.setState({ hasPaid: false, hasAutopayDetails: false });
        });
    };

    handleOnPlaidSuccess = (plaidToken, plaidMetadata) => {
      const paymentDetails = {
        selectedAccount: plaidMetadata['account']['id'],
        plaidToken: plaidToken,
      };
      this.props
        .acceptApplicationPayment(null, paymentDetails)
        .then(() => {
          this.setState({ hasPaid: true, hasAutopayDetails: true });
        })
        .catch(() => {
          this.setState({ hasPaid: false, hasAutopayDetails: false });
        });
    };

    handlePaymentByCreditSuccess = () => {
      this.setState({
        hasPaid: true,
        hasAutopayDetails: false,
        paymentDialogOpen: false,
      });
    };

    submitForm = formData => {
      const query = browserHistory.getCurrentLocation().query;
      const { tenantApplication } = this.props;
      let hasApplicationFee = tenantApplication && tenantApplication.has_application_fee;
      this.props.showApplicationSending();
      this.props.createTenantApplicationForm(
        formData,
        query.property_id,
        query.application_id,
        query.referrer,
        query.renewal_id,
        hasApplicationFee
      );
    };

    togglePadAgreement = () => {
      if (!this.props.tenantApplication.total_monthly_payment) {
        return this.nextPage();
      }
      this.setState({ padAgreementOpen: !this.state.padAgreementOpen });
    };

    togglePaymentDialog = () => {
      this.setState({ paymentDialogOpen: !this.state.paymentDialogOpen });
    };

    saveApplicationDetails = applicationDetails => {
      this.submitForm(applicationDetails);
    };

    nextPage() {
      const usePaymentPlatform = this.props.tenantApplication.use_payment_platform;
      const hidePaymentOptionSelectionPageDuringApplication = this.props.tenantApplication
        .hide_payment_option_selection_page_during_application;
      const hideBankPaymentDetailsAutopayDuringApplication = this.props.tenantApplication
        .hide_bank_payment_details_autopay_during_application;
      const isGenericApplication =
        this.props.tenantApplication.is_generic ??
        !this.props.tenantApplication.lease_details.lease_start_date;
      const preApplicationInstructions = this.props.tenantApplication.pre_application_instructions;
      const isGuarantor = this.props.tenantApplication.is_guarantor;
      const isRenewal = this.props.tenantApplication.is_renewal;
      let coApplicantsInApplication = this.props.tenantApplication.coapplicants_in_application;
      const hasDepositToPay = !!this.props.tenantApplication.total_application_payable;
      const hasPaidDeposit = this.props.tenantApplication.has_paid_deposit;
      const skipDepositPaymentPage =
        hidePaymentOptionSelectionPageDuringApplication || !hasDepositToPay || hasPaidDeposit;

      if (coApplicantsInApplication === null) {
        coApplicantsInApplication = true;
      }

      if (isRenewal && (this.state.page === 4 || this.state.page === 3)) {
        if (usePaymentPlatform && this.state.page === 3) {
          this.setState({ page: 4 });
        } else {
          this.setState({ page: 6 });
        }
      } else if (this.state.page === 3 && usePaymentPlatform) {
        if (skipDepositPaymentPage) {
          this.setState({ page: 5 });
        } else {
          this.setState({ page: 4 });
        }
      } else if (this.state.page === 3 && !usePaymentPlatform && !coApplicantsInApplication) {
        this.setState({ page: 6 });
      } else if (this.state.page === 3 && !usePaymentPlatform) {
        this.setState({ page: 5 });
      } else if (
        this.state.page === 2 &&
        this.props.tenantApplication.multiTenant &&
        isGenericApplication
      ) {
        this.setState({ page: 6 });
      } else if (
        this.state.page === 2 &&
        !this.props.tenantApplication.multiTenant &&
        isGenericApplication &&
        !coApplicantsInApplication
      ) {
        this.setState({ page: 6 });
      } else if (
        this.state.page === 2 &&
        !this.props.tenantApplication.multiTenant &&
        isGenericApplication
      ) {
        this.setState({ page: 5 });
      } else if (
        this.state.page === 2 &&
        this.props.tenantApplication.multiTenant &&
        this.props.tenantApplication.is_generic
      ) {
        this.setState({ page: 6 });
      } else if (
        this.state.page === 2 &&
        this.props.tenantApplication.multiTenant &&
        this.props.tenantApplication.lease_details.lease_start_date &&
        !usePaymentPlatform
      ) {
        this.setState({ page: 6 });
      } else if (this.state.page === 4 && this.props.tenantApplication.multiTenant) {
        this.setState({ page: 6 });
      } else if (this.state.page === 0) {
        this.setState({ page: 1 });
        this.props.explosionCelebration();
      } else if (
        this.state.page === 1 &&
        (!preApplicationInstructions || preApplicationInstructions === '')
      ) {
        this.setState({ page: 3 });
      } else if (this.state.page === 12 && !usePaymentPlatform) {
        this.setState({ page: 14 });
      } else if (this.state.page === 12 && usePaymentPlatform) {
        if (hideBankPaymentDetailsAutopayDuringApplication) {
          this.setState({ page: 14 });
        } else {
          this.setState({ page: 13 });
        }
      } else if (
        !this.state.padAgreementOpen &&
        this.state.page === 13 &&
        this.props.tenantApplication.total_monthly_payment
      ) {
        this.togglePadAgreement();
      } else if (this.state.padAgreementOpen && this.state.page === 13) {
        this.togglePadAgreement();
        this.setState({ page: 14 });
      } else if (this.state.page === 4 && !coApplicantsInApplication) {
        this.setState({ page: 6 });
      } else if (this.state.page === 9 && isGuarantor) {
        this.props.displayOccupationForm();
        this.setState({ page: 10 });
      } else if (this.state.page === 9) {
        this.props.displayIsStudentForm();
        this.setState({ page: 10 });
      } else if (this.state.page === 10 && !isGuarantor) {
        this.setState({ page: 12 });
      } else if (this.state.page === 11 && isGuarantor) {
        this.setState({ page: 14 });
      } else {
        this.setState({ page: this.state.page + 1 });
      }
    }

    goToBeginningOfAcknowledgement = preApplicationInstructions => {
      if (!preApplicationInstructions || preApplicationInstructions === '') {
        this.setState({ page: 1 });
      } else {
        this.setState({ page: 2 });
      }
    };

    previousPage() {
      const usePaymentPlatform = this.props.tenantApplication.use_payment_platform;
      const preApplicationInstructions = this.props.tenantApplication.pre_application_instructions;
      const isGuarantor = this.props.tenantApplication.is_guarantor;

      const hideBankPaymentDetailsAutopayDuringApplication = this.props.tenantApplication
        .hide_bank_payment_details_autopay_during_application;
      const hidePaymentOptionSelectionPageDuringApplication = this.props.tenantApplication
        .hide_payment_option_selection_page_during_application;
      const isGenericApplication =
        this.props.tenantApplication.is_generic ??
        !this.props.tenantApplication.lease_details.lease_start_date;
      const isRenewal = this.props.tenantApplication.is_renewal;
      let coApplicantsInApplication = this.props.tenantApplication.coapplicants_in_application;
      const hasDepositToPay = !!this.props.tenantApplication.total_application_payable;
      const hasPaidDeposit = this.props.tenantApplication.has_paid_deposit;
      const skipDepositPaymentPage =
        hidePaymentOptionSelectionPageDuringApplication || !hasDepositToPay || hasPaidDeposit;

      if (coApplicantsInApplication === null) {
        coApplicantsInApplication = true;
      }
      if (isRenewal && this.state.page === 6) {
        if (usePaymentPlatform) {
          this.setState({ page: 4 });
        } else {
          this.setState({ page: 3 });
        }
      } else if (this.state.page === 5 && usePaymentPlatform) {
        if (skipDepositPaymentPage) {
          this.setState({ page: 3 });
        } else {
          this.setState({ page: 4 });
        }
      } else if (
        this.state.page === 5 &&
        !usePaymentPlatform &&
        this.props.tenantApplication.lease_details.lease_start_date
      ) {
        this.setState({ page: 3 });
      } else if (this.state.page === 5 && !usePaymentPlatform && isGenericApplication) {
        this.goToBeginningOfAcknowledgement(preApplicationInstructions);
      } else if (this.state.page === 6 && usePaymentPlatform && !coApplicantsInApplication) {
        this.setState({ page: 4 });
      } else if (
        this.state.page === 6 &&
        !usePaymentPlatform &&
        !coApplicantsInApplication &&
        this.props.tenantApplication.lease_details.lease_start_date
      ) {
        this.setState({ page: 3 });
      } else if (
        this.state.page === 6 &&
        this.props.tenantApplication.multiTenant &&
        this.props.tenantApplication.lease_details.lease_start_date &&
        !usePaymentPlatform
      ) {
        this.setState({ page: 5 });
      } else if (
        this.state.page === 6 &&
        this.props.tenantApplication.multiTenant &&
        usePaymentPlatform
      ) {
        this.setState({ page: 4 });
      } else if (
        this.state.page === 6 &&
        !usePaymentPlatform &&
        !coApplicantsInApplication &&
        isGenericApplication
      ) {
        this.goToBeginningOfAcknowledgement(preApplicationInstructions);
      } else if (this.state.page === 4 && !this.props.tenantApplication) {
        this.goToBeginningOfAcknowledgement(preApplicationInstructions);
      } else if (this.state.page === 4 && isGenericApplication) {
        this.goToBeginningOfAcknowledgement(preApplicationInstructions);
      } else if (this.state.page === 14 && isGuarantor) {
        this.setState({ page: 11 });
      } else if (this.state.page === 14 && !usePaymentPlatform) {
        this.setState({ page: 12 });
      } else if (this.state.page === 14 && usePaymentPlatform) {
        if (hideBankPaymentDetailsAutopayDuringApplication) {
          this.setState({ page: 12 });
        } else {
          this.setState({ page: 13 });
        }
      } else if (this.state.page === 6 && !coApplicantsInApplication) {
        this.setState({ page: 4 });
      } else if (this.state.page === 3) {
        this.goToBeginningOfAcknowledgement(preApplicationInstructions);
      } else {
        this.setState({ page: this.state.page - 1 });
      }
    }

    showCotenantsForm = () => {
      this.props.showCotenantsForm();
    };

    hideCotenantsForm = () => {
      this.props.hideCotenantsForm();
    };

    showPetsForm = () => {
      this.props.showPetsForm();
    };

    hidePetsForm = () => {
      this.props.hidePetsForm();
    };

    showVehiclesForm = () => {
      this.props.showVehiclesForm();
    };

    hideVehiclesForm = () => {
      this.props.hideVehiclesForm();
    };

    showOtherOccupantsForm = () => {
      this.props.displayOtherOccupantsForm();
    };

    hideOtherOccupantsForm = () => {
      this.props.hideOtherOccupantsForm();
    };

    isCurrentlyAStudent = () => {
      this.props.displayIsStudentForm();
    };

    isCurrentlyEmployed = () => {
      this.props.displayOccupationForm();
    };

    showPreviousOccupationForm = () => {
      this.props.showPreviousOccupationForm();
    };

    hidePreviousOccupationForm = () => {
      this.props.hidePreviousOccupationForm();
    };

    showLandlordReferenceForm = () => {
      this.props.showLandlordReferenceForm();
    };

    hideLandlordReferenceForm = () => {
      this.props.hideLandlordReferenceForm();
    };

    creditCardPricing = () => {
      let { tenantApplication } = this.props;
      tenantApplication = tenantApplication || {};

      const totalApplicationPayableCredit = tenantApplication.total_application_payable_credit;
      const processingFee = tenantApplication.processing_fee;
      const subtotal = tenantApplication.total_application_payable;

      const pricingObject = {
        total: totalApplicationPayableCredit,
      };

      if (processingFee) {
        // only populate subtotal and processing fee if there is a processing fee
        pricingObject.subtotal = subtotal;
        pricingObject.processing_fee = processingFee;
      }

      return pricingObject;
    };

    render() {
      const { page } = this.state;
      const query = browserHistory.getCurrentLocation().query;
      const { showApplicationFeePayment, tenantApplication, createdApplicationID } = this.props;
      const propertyName = tenantApplication ? tenantApplication.property : '';
      const leaseDetails = tenantApplication ? tenantApplication.lease_details : '';
      const avatar = tenantApplication ? tenantApplication.avatar : '';
      const landlordName = tenantApplication ? tenantApplication.landlordName : 'yuhu';
      const totalApplicationPayable = tenantApplication
        ? tenantApplication.total_application_payable
        : '';
      const autopayProcessingFee = tenantApplication ? tenantApplication.autopay_fee : '';
      const totalApplicationPayableCredit = (tenantApplication || {})
        .total_application_payable_credit;
      const processingFee = (tenantApplication || {}).processing_fee;
      const hasApplicationFee = tenantApplication && tenantApplication.has_application_fee;
      const applicationFeeAmount = tenantApplication && tenantApplication.application_fee_amount;
      const applicationId = query?.application_id || createdApplicationID;
      const forceDepositCreditCard = tenantApplication
        ? tenantApplication.force_deposit_credit_card
        : false;

      let showAdditionalLeadDetail = false;
      if (leaseDetails && !leaseDetails.lease_start_date && !tenantApplication.multiTenant) {
        showAdditionalLeadDetail = true;
      }

      return (
        <Fragment>
          <PADAgreementDialog
            onSubmit={this.nextPage}
            isOpen={this.state.padAgreementOpen}
            tenantOverview={tenantApplication ? tenantApplication : {}}
            toggleDialog={this.togglePadAgreement}
            processingFee={autopayProcessingFee}
            handleBackAutopayStep={this.togglePadAgreement}
            isApplication
          />
          {deepDiver(this.props, 'tenantApplication.payment_provider') === 'paysafe' ? (
            <PaysafeTenantPayment
              open={this.state.paymentDialogOpen}
              toggleOpen={this.togglePaymentDialog}
              fullScreen={this.props.fullScreen}
              outstandingBalance={tenantApplication.total_application_payable}
              authorizePayment={this.props.authorizeApplicationPayment}
              makePayment={this.props.acceptApplicationPayment}
              onSuccess={this.handlePaymentByCreditSuccess}
              paymentHold
              lockedAmount
              paymentType={'deposit'}
            />
          ) : (
            <StripePayment
              open={this.state.paymentDialogOpen}
              toggleOpen={this.togglePaymentDialog}
              fullScreen={this.props.fullScreen}
              pricing={this.creditCardPricing()}
              onToken={this.processCreditCardPayment}
              additionalVerbiage="The total amount due includes your deposit, rent amount, first months rent and any ancillary item deposits (such as parking). Your card will not be charged until your application has been accepted."
              submitButtonVerbiage="Authorize Payment and Continue"
            />
          )}
          {hasApplicationFee && (
            <TenantPaymentOptions
              header="A fee is required before submitting your application. Please select a payment option"
              subHeader="Please Note: This application fee is non-refundable."
              togglePayDialog={() => {
                toggleApplicationFeePaymentModal(false);
              }}
              payDialogOpen={showApplicationFeePayment}
              paymentDetails={{
                outstanding_balance: applicationFeeAmount,
                application_id: applicationId,
                payment_type: 'app_fee',
              }}
              tenantOverview={tenantApplication ? tenantApplication : {}}
              lockedAmount
              hideClose
              showFeeInfo
              hideAutoPayVerbiage
            />
          )}
          {page === 0 && (
            <WizardWelcomePage
              onSubmit={this.nextPage}
              property={propertyName}
              hasApplicationFee={hasApplicationFee}
            />
          )}
          {page === 1 && (
            <WizardConsentPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
              privacyStatementLink={this.props.privacyStatementLink}
            />
          )}
          {page === 2 && (
            <WizardAdditionalInformationPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
              preApplicationInstructions={tenantApplication.pre_application_instructions}
            />
          )}
          {page === 3 &&
            leaseDetails && (
              <WizardLeaseDetailsPage
                previousPage={this.previousPage}
                onSubmit={this.nextPage}
                applicationDetails={tenantApplication}
                leaseDetails={leaseDetails}
                showAdditionalLeadDetail={showAdditionalLeadDetail}
                propertyName={propertyName}
              />
            )}
          {page === 4 &&
            leaseDetails && (
              <WizardLeasePaymentsPage
                landlordName={landlordName}
                previousPage={this.previousPage}
                onSubmit={this.nextPage}
                openCreditCard={this.togglePaymentDialog}
                dontForcePayment={!forceDepositCreditCard}
                totalPaymentAmount={totalApplicationPayable}
                totalPaymentAmountCredit={totalApplicationPayableCredit}
                processingFee={processingFee}
                handleOnPlaidSuccess={this.handleOnPlaidSuccess}
                hasPaid={this.state.hasPaid}
                paymentProvider={deepDiver(this.props, 'tenantApplication.payment_provider')}
              />
            )}
          {page === 5 && (
            <WizardFormSecondPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
              showCotenantsForm={this.showCotenantsForm}
              hideCotenantsForm={this.hideCotenantsForm}
              showAdditionalLeadDetail={showAdditionalLeadDetail}
            />
          )}
          {page === 6 && (
            <WizardDetailPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
              avatar={avatar}
              showAdditionalLeadDetail={showAdditionalLeadDetail}
            />
          )}
          {page === 7 && (
            <WizardBioPage previousPage={this.previousPage} onSubmit={this.nextPage} />
          )}
          {page === 8 && (
            <WizardQuestionsPage previousPage={this.previousPage} onSubmit={this.nextPage} />
          )}
          {page === 9 && (
            <WizardCurrentAddressPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
              isStudent={this.isCurrentlyAStudent}
              isNotStudent={this.isCurrentlyEmployed}
            />
          )}
          {page === 10 && (
            <WizardOccupationPage previousPage={this.previousPage} onSubmit={this.nextPage} />
          )}
          {page === 11 && (
            <WizardPreviousOccupationPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
              showPreviousOccupationForm={this.showPreviousOccupationForm}
              hidePreviousOccupationForm={this.hidePreviousOccupationForm}
            />
          )}
          {page === 12 && (
            <EmergencyContactsPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
              deletePersonalReference={this.props.deletePersonalReference}
            />
          )}
          {page === 13 && (
            <PaymentDetails
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
              hasAutopayDetails={this.state.hasAutopayDetails}
              skipPayment={() => this.setState({ page: 14 })}
              padDetailType={tenantApplication && tenantApplication.pad_detail_type}
            />
          )}
          {page === 14 && (
            <WizardIdUploadPage
              previousPage={this.previousPage}
              onSubmit={this.saveApplicationDetails}
              deleteProofOfIncomeUpload={this.props.deleteProofOfIncomeUpload}
              deleteIdentificationUpload={this.props.deleteIdentificationUpload}
              overrideID={tenantApplication.bypass_id}
              isGuarantor={tenantApplication.is_guarantor}
              fileErrors={this.props.uploadedFileErrorsArray}
            />
          )}
        </Fragment>
      );
    }
  }
);

export default withMobileDialog()(TenantApplication);
